export default __webpack_public_path__ + "static/media/rabab.2b544c12.png";